import { http } from '@/api/_base';
import store from '@/store';

const set_user = () => {
	return http
		.get('/user/profile', { withCredentials: true })
		.then(res => {
			store.commit('setUser', res.data);
		})
		.catch(error => {
			//alert(error.response.status + ' ' + error.response.data);
			store.commit('setUser', null);
		});
};

const login = (username: string, password: string) => {
	return http
		.post(
			'/user/login',
			{},
			{
				auth: { username: username, password: password },
				withCredentials: true
			}
		)
		.then(res => res.data);
};

const logout = () => {
	return http
		.post(
			'/user/logout',
			{},
			{
				withCredentials: true
			}
		)
		.then(res => res.data);
};

export { set_user, login, logout };
